<template>
  <div class="mxr-l-borders" v-if="showBorders">
    <div class="mxr-l-borders--top">
      <span class="left" v-if="showCorners"></span>
      <span class="right" v-if="showCorners"></span>
    </div>
    <div class="mxr-l-borders--right" :class="{hasLabel: nextLabel}">
      <div class="mxr-l-borders__next number" @click="getNext" v-if="nextLabel">{{nextLabel | padToTwo}}</div>
      <div class="mxr-l-borders__next arrow show-for-medium" @click="getNextSlider" v-if="nextArrow"><i class="zmdi zmdi-long-arrow-right"></i></div>
    </div>
    <div class="mxr-l-borders--bottom">
      <span class="left" v-if="showCorners"></span>
      <span class="right" v-if="showCorners"></span>
      <div class="mxr-l-borders__title" v-if="showGender !== undefined">
        12 outfits
        <span>{{ genderType }}</span>
      </div>
      <button class="mxr-look__scroll mxr-l-borders__scroll show-for-medium" v-if="showChevronDown"><i class="zmdi zmdi-long-arrow-down"></i></button>
    </div>
    <div class="mxr-l-borders--left" :class="{hasLabel: prevLabel}">
      <div class="mxr-l-borders__vtext" v-if="showText">#DRESSYOURRUN</div>
      <div class="mxr-l-borders__prev number" @click="getPrev" v-if="prevLabel">{{prevLabel | padToTwo}}</div>
      <div class="mxr-l-borders__prev arrow show-for-medium" @click="getPrevSlider" v-if="prevArrow"><i class="zmdi zmdi-long-arrow-left"></i></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'borders',
    props: {
      showCorners: {
        type: Boolean,
        required: true,
      },
      showText: {
        type: Boolean,
        required: true,
      },
      prevLabel: {
        type: [String, Number],
        required: false,
      },
      nextLabel: {
        type: [String, Number],
        required: false,
      },
      nextArrow: {
        type: Boolean,
        required: false,
      },
      prevArrow: {
        type: Boolean,
        required: false,
      },
      showGender: {
        type: String,
        required: false,
      },
      showChevronDown: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data() {
      return {
        showScroll: false,
      };
    },
    computed: {
      showBorders() {
        return this.$store.state.showBorders;
      },
      genderType() {
        let gender = '';
        if (this.showGender === 'men') {
          gender = 'Uomo';
        } else if (this.showGender === 'women') {
          gender = 'Donna';
        }
        return gender;
      },
    },
    methods: {
      getNext() {
        this.$root.$emit('goto', 'next');
      },
      getPrev() {
        this.$root.$emit('goto', 'prev');
      },
      getNextSlider() {
        this.$root.$emit('posSlider', 'next');
      },
      getPrevSlider() {
        this.$root.$emit('posSlider', 'prev');
      },
    },
    mounted() {
    },
  };
</script>

<style lang="scss" scoped>
$corners-size : rem-calc(18);
$corners-border-width: 2;
$bar-width: rem-calc(28);
  // .l-* stands for layout.
  .mxr-l-borders {
    &__title {
      text-align: left;
      position: absolute;
      left: rem-calc($borders-width-md);
      margin-left: rem-calc(20);
      top: 0;
      transform: translateY(-50%);
      font-size: rem-calc(14);
      letter-spacing: .311em;
      margin-right: rem-calc(-.311em);
      font-family: $body-font-family-alt;
      text-transform: uppercase;
      margin-top: rem-calc(-10);
      font-weight: $global-weight-bold;
      line-height: 1.35;
      color: $black;
      span {
        font-size: rem-calc(22);
        display: block;
      }
      @include breakpoint(small only) {
        // color: darken($blue-gray, 5%);
        transform-origin: 0 0;
        transform: rotate(-90deg);
        left: 0;
        top: auto;
        bottom: rem-calc(24);
        font-size: rem-calc(12);
        span {
          font-size: rem-calc(18);
          // color: darken($blue-gray, 25%);
        }
      }
    }
  }
  .mxr-l-borders {
    &__prev, &__next {
      position: absolute;
      padding: rem-calc(14);
      top: 50%;
      transform: translateY(-50%);
      font-size: rem-calc(12);
      font-weight: $global-weight-bold;
      &:before {
        content: '';
        position: absolute;
        background: $black;
        height: rem-calc(2);
        width: rem-calc(10);
        top: 50%;
        transform: translateY(-50%);
        margin-top: rem-calc(-1);
      }
    }
    &__next {
      right: 0;
      &:before {
        right: 0;
      }
    }
    &__prev {
      left: 0;
      &:before {
        left: 0;
      }
    }
  }
  @include breakpoint(medium) { 
    .mxr-l-borders {
      position: relative;
      z-index: 0;

      &__prev, &__next {
        position: absolute;
        color: $black;
        top: 50%;
        transform: translateY(-50%);
        font-size: rem-calc(12);
        cursor: pointer;
        padding-top: rem-calc(6);
        padding-bottom: rem-calc(6);
        font-weight: $global-weight-bold;
        letter-spacing: .2em;

        &:hover {
          transform: translateY(-50%);
        }
        &.arrow {
          font-size: rem-calc(22);
          &:before {
            display: none;
          }
        }
        &.number {
          &:before {
            content: '';
            position: absolute;
            height: rem-calc(2);
            width: $bar-width;
            background: $black;
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }

      &__next {
        right: 0;
        transform-origin: 50% 0;
        &:before {
          right: 0;
        }
        &.number {
          padding-left: rem-calc(6);
          padding-right: $bar-width + rem-calc(6);
        }
        &.arrow {
          padding-left: rem-calc(3);
          padding-right: $bar-width;
        }
      }
      &__prev {
        left: 0;
        padding-left: $bar-width + rem-calc(6);
        transform-origin: 50% 0;
        &:before {
          left: 0;
        }
        &.number {
          padding-right: rem-calc(6);
          padding-left: $bar-width + rem-calc(6);
        }
        &.arrow {
          padding-right: rem-calc(3);
          padding-left: $bar-width;
        }
      }

      .left, .right {
        height: $corners-size;
        width: $corners-size;
        background: transparent;
        display: block;
        position: absolute;
      }

      &--top, &--bottom {
        height: rem-calc($borders-width-md);
        width: 100vw;
      }
      &--left, &--right {
        width: rem-calc($borders-width-md);
        top: 0;
        bottom: rem-calc($nav-height);
        /* &.hasLabel {
          transition: width $anim-curve .4s ;
          &:hover {
            width: rem-calc(55);
          }
        } */
      }
      > * {
      background: $white;
      position: fixed;
      z-index: 100
    }
      &--top {
        top: 0;
        transform-origin: top center;
        z-index: 103;
        height: rem-calc($borders-width-md);
        .left {
          left: rem-calc($borders-width-md) - rem-calc($corners-border-width);
          top: rem-calc($borders-width-md) - rem-calc($corners-border-width);
          box-shadow: inset rem-calc($corners-border-width $corners-border-width 0 0) $black;
        }
        .right {
          right: rem-calc($borders-width-md) - rem-calc($corners-border-width);
          top: rem-calc($borders-width-md) - rem-calc($corners-border-width);
          box-shadow: inset rem-calc(-$corners-border-width $corners-border-width 0 0) $black;
        }
      }
      &--bottom {
        bottom: rem-calc($nav-height);
        transform-origin: bottom center;
        z-index: 103;

        .left {
          left: rem-calc($borders-width-md) - rem-calc($corners-border-width);
          bottom: rem-calc($borders-width-md) - rem-calc($corners-border-width);
          box-shadow: inset rem-calc($corners-border-width (-$corners-border-width) 0 0) $black;
        }
        .right {
          right: rem-calc($borders-width-md) - rem-calc($corners-border-width);
          bottom: rem-calc($borders-width-md) - rem-calc($corners-border-width);
          box-shadow: inset rem-calc(-$corners-border-width (-$corners-border-width) 0 0) $black;
        }
      }
      &--left {
        left: 0;
        transform-origin: left center;
      }
      &--right {
        right: 0;
        transform-origin: right center;
      }
      &__vtext {
        position: absolute;
        top: 50%;
        transform-origin: 50% 50%;
        transform: rotateZ(-90deg);
        left: rem-calc(-40);
        letter-spacing: rem-calc(7.11);
        font-weight: $global-weight-bold;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Borders.vue?3d79985a